module.exports = __webpack_public_path__ + "img/palau.7b86451.webp";